import { createContext, useContext, type ReactNode } from "react"
import { useDarkMode } from "@/hooks/useDarkMode"

interface ThemeContextType {
  isDark: boolean
  toggle: () => void
  setLight: () => void
  setDark: () => void
}

const ThemeContext = createContext<ThemeContextType>({
  isDark: false,
  toggle: () => {},
  setLight: () => {},
  setDark: () => {},
})

export function ThemeProvider({ children }: { children: ReactNode }) {
  const darkMode = useDarkMode()
  return <ThemeContext.Provider value={darkMode}>{children}</ThemeContext.Provider>
}

// eslint-disable-next-line react-refresh/only-export-components
export const useTheme = () => useContext(ThemeContext)
